module.exports = __webpack_public_path__ + "img/鹤壁市-c.cab687f0.png";